import { MdVolumeUp, MdVolumeOff } from "react-icons/md";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

interface VoiceModeToggleProps {
  enabled: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const VoiceModeToggle = ({ enabled, onToggle, disabled = false }: VoiceModeToggleProps) => {
  const { t } = useTranslation();
  const tooltipTitle = enabled ? t("voice.disableTooltip") : t("voice.enableTooltip");

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span className="inline-flex items-center gap-1.5">
        {enabled ? (
          <MdVolumeUp size={18} className="text-green-500" />
        ) : (
          <MdVolumeOff size={18} className="text-gray-400" />
        )}
        <span
          className={`text-xs font-medium select-none ${
            enabled ? "text-green-700" : "text-gray-500"
          }`}
        >
          {t("voice.modeLabel")}
        </span>
        <Switch
          checked={enabled}
          onChange={onToggle}
          disabled={disabled}
          size="small"
          inputProps={{ "aria-label": t("voice.toggleAriaLabel") }}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "#00b47b",
              "&:hover": {
                backgroundColor: "rgba(0, 180, 123, 0.08)",
              },
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#00c889",
            },
          }}
        />
      </span>
    </Tooltip>
  );
};

export default VoiceModeToggle;
